<template>
  <div class="loader">
    <div uk-spinner class="spinner"></div>
    <span class="loader__text">
      <slot>{{textOrDefault}}</slot>
    </span>
  </div>
</template>

<script>
import DynamicProps from '@/mixins/DynamicProps';

export default {
  name: 'loader',
  mixins: [DynamicProps],
  props: {
    text: String,
  },
  computed: {
    textOrDefault() {
      return this.text || this.$t('loader.loading');
    },
  },
  i18n: {
    messages: {
      de: {
        loader: {
          loading: 'Lade',
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.loader {
  pointer-events: none;
  user-select: none;
  display: inline-block;
}

.loader__text {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// Loader.vue?0fed3cb4